<div class="cookies-message" *ngIf="!cookiesBannerDismissed">

  <div *ngIf="!cookieSettingsOpen" class="cookies-text">
    <b>{{getString('cookiesTitle')}}</b><br>
    <span *ngIf="isEU">{{getString('cookiesMessageEU')}}</span>
    <span *ngIf="!isEU">{{getString('cookiesMessage')}}</span>
    <a [routerLink]="'/' + getCountry() + '/' + getString('privacyPolicyUrl')" target="_blank">{{getString('privacyPolicy')}}</a>.
  </div>

  <div *ngIf="isEU && !cookieSettingsOpen" class="btn-container">
    <button type="button" (click)="settings()" class="black-button">{{getString('settings')}}</button>
    <button type="button" (click)="decline()" class="button">{{getString('decline')}}</button>
    <button type="button" (click)="accept()" class="blue-button">{{getString('acceptAll')}}</button>
  </div>

  <div *ngIf="!isEU" class="btn-container">
    <button type="button" (click)="accept()" class="blue-button">{{getString('understood')}}</button>
  </div>

</div>

<app-modal #cookieSettingsModal [showCloseButton]="false" [title]="getString('cookieSettings')">
  <app-cookie-settings [showTitle]="false" (onClose)="applySettings($event)"></app-cookie-settings>
</app-modal>